import { Data } from "@angular/router";

export class BeneficiaryAccountProperties {
  name: string = "";
  reference: string = "";
  agencyId: string = "";
  accountNo: string = "";
  accountTitle: string = "";
  branch: string = "";
  bankName: string = "";
  iban: string = "";
  swift: string = "";
  creationUser: number = 0;
  creationTime: Date;
  modifyUser: number = 0;
  modifyTime: Data;
  isActive: boolean;
  beneficiaryId: number = 0;
  backSystemCompanyId: number;
  glAccountNumber: string = "";
  glAccountName: string;
  bankId: number = 0;
  branchLocation: string;
}
export class ERPBackOffliceBankList {
  bankId: number;
  bankName: string;
  glAccountNumber: string;
  glAccountName: string;
  branchLocation: string
  backSystemCompanyId: number;
}
export class AgencyMasterProperties {
  agencyId: string = "";
  agencyName: string = "";
  satus: boolean;
  emailAddress: string = "";
  notificationEmail: string;
  agencyType: number = 0;
  address1: string = "";
  address2: string = "";
  country: string = "";
  city: string = "";
  zip: string = "";
  currency: number = 0;
  language: number = 0;
  mobileContact: string = "";
  telephoneNumber: string = "";
  fax: string = "";
  maximumUsers: number = 0;
  managerName: string = "";
  managerEmailAddress: string = "";
  managerPhone: string = "";
  settlementMode: number = 0;
  creditLimit: number = 0;
  logoFileName: string = "";
  logoFilePath: string = "";
  creationDate: Date;
  creationUser: number = 0;
  modifyDate: Date;
  modifyUser: number = 0;
  parentAgency: string = "";
  agencyLevel: number = 0;
  backSystemCustomerId: string = "";
  parentBranch: string = "";
  isMasterAgency: boolean;
  groupId: string = "";
  agencyColourCode: string = "";
}
export class BeneficiaryAccountAllocationProperties {
  allocationId: number = 0;
  allocatedAgencyId: string = "";
  agencyId: string = "";
  accountNo: string = "";
  creationUser: number = 0;
  modifyUser: number = 0;
  creationTime: Date;
  modifyTime: Date;
  isActive: boolean;
}
export class GetAllocatedAccountsProperties {
  allocationId: number;
  agencyId: string = "";
  agencyName: string = "";
  name: string = "";
  accountNo: string = "";
  isActive: boolean;

  reference: string = "";

  accountTitle: string = "";
  branch: string = "";
  bankName: string = "";
  iban: string = "";
  swift: string = "";

}
